// src/js/contact.js

/**
 * VALIDATION: Checks the current visible section or a specific section by index.
 * Moved to top scope so it's accessible by both UI buttons and handleSubmit.
 */
function validateSection(index, form) {
  const sections = [...form.querySelectorAll(".contact-section")];
  const currentSection = sections[index];
  if (!currentSection) return false;

  let isValid = true;

  // 1. Check Standard Inputs (text, email, date, time, textarea, select)
  const inputs = currentSection.querySelectorAll(
    "input:not([type='radio']):not([type='hidden']), select, textarea",
  );
  inputs.forEach((input) => {
    input.classList.remove("input-error");
    // Only validate if the field is required
    if (input.hasAttribute("required") && input.value.trim() === "") {
      isValid = false;
      input.classList.add("input-error");
    }
  });

  // 2. Check Radio Groups (Payment)
  const radioGroups = [
    ...new Set(
      [...currentSection.querySelectorAll("input[type='radio']")].map(
        (r) => r.name,
      ),
    ),
  ];
  radioGroups.forEach((groupName) => {
    const radios = currentSection.querySelectorAll(
      `input[name="${groupName}"]`,
    );
    // Radio buttons are required if at least one in the group has the 'required' attribute
    // or if you want to force payment selection specifically.
    const isAnyChecked = [...radios].some((r) => r.checked);

    if (!isAnyChecked) {
      isValid = false;
      currentSection.querySelector("fieldset")?.classList.add("input-error");
    } else {
      currentSection.querySelector("fieldset")?.classList.remove("input-error");
    }
  });

  return isValid;
}

/**
 * Form submission via AJAX
 */
const handleSubmit = (event) => {
  event.preventDefault();

  const myForm = event.target;
  const formData = new FormData(myForm);

  // 1. HONEYPOT CHECK
  if (formData.get("bot-field")) {
    return; // Silent fail for bots
  }

  // 2. FINAL VALIDATION GUARD
  // We check the last section (Payment) one last time before allowing the fetch
  const sections = myForm.querySelectorAll(".contact-section");
  if (!validateSection(sections.length - 1, myForm)) {
    alert("Please select a payment method.");
    return;
  }

  // 3. SPAM FILTER
  const notes = formData.get("notes") || "";
  const linkPattern = /(https?:\/\/\S+|www\.\S+|[\da-z-]+\.[a-z]{2,})/gi;
  if (linkPattern.test(notes)) {
    alert("Links are not permitted in the notes field.");
    return;
  }

  // 4. SUBMIT TO NETLIFY
  const payload = new URLSearchParams(formData);
  const subject = `Website Enquiry: ${formData.get("name")} - ${formData.get("date")} @ ${formData.get("pickup-time")}`;
  payload.set("subject", subject);

  fetch("/", {
    method: "POST",
    headers: { "Content-Type": "application/x-www-form-urlencoded" },
    body: payload.toString(),
  })
    .then((response) => {
      if (response.ok) {
        window.location.href = "/contact-us-success";
      } else {
        throw new Error("Submission failed.");
      }
    })
    .catch((error) => alert(error));
};

/**
 * UI Logic
 */
document.addEventListener("DOMContentLoaded", () => {
  const form = document.querySelector("#justaxis-contact-form");
  if (!form) return;

  const sections = [...form.querySelectorAll(".contact-section")];
  const nextBtn = form.querySelector(".next");
  const backBtn = form.querySelector(".back");
  const sendBtn = form.querySelector(".send");

  let currentIndex = 0;

  function showSection(index) {
    sections.forEach((section, i) => {
      section.style.display = i === index ? "block" : "none";
    });

    backBtn.style.display = index > 0 ? "inline-block" : "none";
    nextBtn.style.display =
      index < sections.length - 1 ? "inline-block" : "none";
    sendBtn.style.display =
      index === sections.length - 1 ? "inline-block" : "none";
  }

  nextBtn.addEventListener("click", (e) => {
    e.preventDefault();
    if (validateSection(currentIndex, form)) {
      currentIndex++;
      showSection(currentIndex);
      window.scrollTo(0, 0);
    } else {
      alert("Please complete the required fields.");
    }
  });

  backBtn.addEventListener("click", (e) => {
    e.preventDefault();
    if (currentIndex > 0) {
      currentIndex--;
      showSection(currentIndex);
    }
  });

  form.addEventListener("submit", handleSubmit);

  showSection(currentIndex);
});
